import { Box, TextField, TextFieldProps, Typography } from '@mui/material';
import { styled } from '@mui/system';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    background: 'transparent',
    borderRadius: '16px',
    color: '#FFFFFF',
    fontFamily: 'Space Grotesk',
    outline: 'none',
    fontWeight: 400,
    fontSize: 16,
    '& fieldset': {
      borderColor: '#fff',
    },
    '&:hover fieldset': {
      borderColor: '#fff',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#fff',
    },
    '& input': {
      color: '#fff',
      '&::placeholder': {
        color: '#A1A1AA',
        opacity: 1,
      },
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px',
  },
  '& .MuiInputLabel-root': {
    color: 'gray',
    '&.Mui-focused': {
      color: '#fff',
    },
  },
}));

const StyledTextFieldDark = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    background: 'transparent',
    borderRadius: '8px',
    color: '#FFFFFF',
    fontFamily: 'Space Grotesk',
    fontWeight: 400,
    fontSize: 16,
    border: '0.5px solid #AEAEAE',
    '& fieldset': {
      borderColor: '#AEAEAE',
    },
    '&:hover fieldset': {
      borderColor: '#4949C8',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4949C8',
    },
    '& input': {
      color: '#FFFFFF',
      '&::placeholder': {
        color: '#fff',
        opacity: 1,
      },
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px',
  },
  '& .MuiInputLabel-root': {
    color: '#A1A1AA',
    '&.Mui-focused': {
      color: '#4949C8',
    },
  },
}));

export interface OnboardingInputProps extends Omit<TextFieldProps, 'variant'> {
  variant?: 'default' | 'dark';
  label?: string;
}

const OnboardingInput: React.FC<OnboardingInputProps> = ({
  variant = 'default',
  label,
  ...props
}) => {
  const Component = variant === 'dark' ? StyledTextFieldDark : StyledTextField;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      {label && (
        <Typography
          sx={{ color: '#FFFFFF', fontWeight: 400, fontSize: 16 }}
          component="label"
        >
          {label}
        </Typography>
      )}
      <Component
        variant="outlined"
        placeholder={props.placeholder}
        fullWidth
        {...props}
        sx={{ background: 'transparent', marginTop: 1, width: '100%' }}
      />
    </Box>
  );
};

export default OnboardingInput;
